import styled from 'styled-components';

export const DateContainer = styled.div`
  ${({pointer}) => pointer && 'margin-top: 80px; margin-bottom: 80px;'}
`;